import { motion } from "framer-motion";
import SectionLabel from "./SectionLabel";

const stats = [
  { value: "80M+", label: "Content Views", caption: "Across podcasts, reels and short form" },
  { value: "100+", label: "Episodes Produced", caption: "From single episodes to full production runs" },
  { value: "<72hr", label: "Turnaround", caption: "From raw recording to publish ready" },
  { value: "100%", label: "Publish Ready", caption: "Delivered ready to upload, no rework" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative px-6 md:px-16 lg:px-32 py-24 md:py-32"
    >
      <SectionLabel number="05" label="By The Numbers" testId="stats-label" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1a1a1a] border-y border-[#1a1a1a]">
        {stats.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            data-testid={`stat-${i}`}
            className="bg-[#050505] p-8 md:p-12 flex flex-col gap-4 hover:bg-[#0A0A0A] transition-colors"
          >
            <div className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter leading-none">
              {s.value}
              <span className="text-[#F4C75E]">.</span>
            </div>
            <div className="text-xs uppercase tracking-[0.25em] text-[#F5F5F5] font-semibold">
              {s.label}
            </div>
            <div className="text-xs text-[#666] leading-relaxed">{s.caption}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
